export default "__VITE_ASSET__7a244ae4__"